export default __webpack_public_path__ + "static/media/people@2x.b884c02c.webp";